import React, { ChangeEvent, FC, useRef, useState } from 'react'
import { InputGroup, Input, Button, Box } from '@chakra-ui/react'
import { Icon } from '../icon'
import theme from '../../styles'
import { CountryInfo } from '../../state/interfaces'

interface countryAutocompleteProps {
  data: CountryInfo[] | null
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
}
export const CountryAutoComplete: FC<countryAutocompleteProps> = ({ data, placeholder, onChange, name }) => {
  const inputElement = useRef<HTMLInputElement>(null)
  const [search, setSearch] = useState<{ text: string; suggestions: CountryInfo[] }>({
    text: '',
    suggestions: [],
  })
  const [isComponentVisible, setIsComponentVisible] = useState(true)
  const onTextChanged = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    let suggestions: CountryInfo[] = []
    if (value.length > 0) {
      const regex = new RegExp(`^${value}`, 'i')
      suggestions = data!.sort().filter((countryInfo: CountryInfo) => regex.test(countryInfo.EN))
    }
    setIsComponentVisible(true)
    setSearch({ suggestions, text: value })
  }

  const suggestionSelected = (countryInfo: CountryInfo) => {
    setIsComponentVisible(false)

    setSearch({
      text: countryInfo.EN,
      suggestions: [],
    })
  }

  const { suggestions } = search

  return (
    <>
      <InputGroup>
        <Input
          ref={inputElement}
          autoComplete="off"
          value={search.text}
          aria-label={placeholder}
          placeholder={placeholder}
          onChange={onTextChanged}
          variant="none"
          fontSize={22}
          name={name}
          maxWidth={371}
          backgroundColor="transparent"
          _placeholder={{ color: 'green.500' }}
          layerStyle={theme.LayerStyles.INPUT}
          onClick={(e) => {
            e.stopPropagation()
            e.currentTarget.focus()
          }}
          onKeyPress={(ev) => {
            if (ev.key === 'Enter' && !isComponentVisible && search.text != '') {
              ev.preventDefault()
              onChange && onChange([search.text])
            }
          }}
          autoFocus
        />
        {!isComponentVisible && search.text != '' && (
          <Button
            role={'button'}
            position="absolute"
            borderRadius="md"
            variant="none"
            layerStyle={theme.LayerStyles.BTN_INPUT_PILL}
            onClick={() => {
              onChange && onChange([search.text])
            }}
          >
            <Icon icon="arrow-right" color="white" />
          </Button>
        )}
      </InputGroup>
      {suggestions.length > 0 && isComponentVisible && (
        <Box boxShadow="lg" borderRadius="md" backgroundColor="white" maxWidth={371}>
          {suggestions.map((item: CountryInfo) => (
            <Button
              key={item.EN}
              onClick={() => suggestionSelected(item)}
              role="option"
              color="black"
              height={10}
              paddingX={5}
              borderRadius="0"
              fontSize="xxs"
              width="full"
              justifyContent="left"
              _hover={{
                color: 'purple',
                backgroundColor: 'purpleAlpha',
              }}
            >
              {item.EN}
            </Button>
          ))}
        </Box>
      )}
    </>
  )
}
